import { render, staticRenderFns } from "./DecorHire.vue?vue&type=template&id=6bf3b5a4&scoped=true&"
import script from "./DecorHire.vue?vue&type=script&lang=js&"
export * from "./DecorHire.vue?vue&type=script&lang=js&"
import style0 from "./DecorHire.vue?vue&type=style&index=0&id=6bf3b5a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf3b5a4",
  null
  
)

component.options.__file = "DecorHire.vue"
export default component.exports